var u = Object.defineProperty;
var f = (t, e, n) => e in t ? u(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var i = (t, e, n) => (f(t, typeof e != "symbol" ? e + "" : e, n), n);
import { P as p } from "./panel-position-9ca63a49.js";
import s from "react";
class h {
  /**
   * コンストラクタ
   * @param lgcode
   */
  constructor(e) {
    /**
     *
     */
    i(this, "lgcode", "");
    this.lgcode = e;
  }
}
function g(t, e = []) {
  return function(a) {
    const d = t.length - 1;
    let o = a.children;
    for (let l = d; l >= 0; l--) {
      const r = t[l], c = e[l];
      c ? o = s.cloneElement(r, { value: c }, o) : o = s.cloneElement(r, void 0, o);
    }
    return o;
  };
}
export {
  g as BuildProviderTree,
  h as MainBase,
  p as PanelPosition
};
